/**
 * compartir-pdf.ts — PR-E E-T5 — S-11.4, S-11.5
 *
 * Pure helpers for the compartirPdf action in TechnicianPanel.
 *
 * buildMailtoEnviar: builds a mailto: URI for the desktop fallback.
 * - mailto CANNOT attach files — it links to the PDF URL instead (S-11.5).
 * - The recipient can open the URL from the email body.
 *
 * The Web Share (file attach) path is handled in TechnicianPanel directly
 * (browser API, not testable in jsdom). S-11.4 is a manual gate.
 *
 * ponytail: pure function; no side effects.
 */

export interface MailtoParams {
  numero: string;
  cliente: string;
  pdfUrl: string;
}

/**
 * Builds a `mailto:` URI for sharing the PDF link via email.
 * Note: mailto cannot attach files — the PDF URL is included in the body.
 */
export function buildMailtoEnviar({ numero, cliente, pdfUrl }: MailtoParams): string {
  const asunto = `Informe ${numero} — ${cliente}`;
  const cuerpo = `Buen día,\n\nAdjunto el informe ${numero} para ${cliente}.\n\nPDF: ${pdfUrl}\n\nSaludos.`;
  return `mailto:?subject=${encodeURIComponent(asunto)}&body=${encodeURIComponent(cuerpo)}`;
}
